<template>
    <div>
        <v-card class="ma-4 py-3 px-5" style="background-color: #5D327C; color: #ffffff;">
            <p class="pt-3 pb-0 px-2">Company information</p>
            <v-card class="mb-3">
                <v-card-text>
                    <v-row>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-text-field type="number" label="User ID" v-model="clientDetails.userID"></v-text-field>
                        </v-col>
                        <v-col cols="6" md="4" class="px-2 py-0 my-0">
                            <v-btn elevation="0" @click="updateDetails" color="primary" block class="button-style mt-3"> 
                                Update Information
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
    </div>
</template>
<script>
import moment from 'moment'
import { VueEditor } from 'vue2-editor'
    export default {
        name: 'CompanyDetails',
        data(){
            return {
                id: this.$route.params.id,
                clientDetails: {}
            }
        },
        methods: {
            getClient(){
                firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
                    this.clientDetails = docSnapshot.data()
                    if(!this.clientDetails.userID){
                        this.clientDetails.userID = 0
                    }
                }, err => { console.log(`Encountered error: ${err}`) })
            },
            updateDetails(){
                firebase.firestore().collection('clients').doc(this.id).update(this.clientDetails)
            }
        },
        mounted(){
            this.getClient()
        }
    }
</script>
<style>
</style>